import BootstrapField from '../utility/BootstrapField';
export default class OrganizationRequest {

	static get getYesNoOptions() {
		return [
			{
				text: 'Yes',
				value: 1
			},
			{
				text: 'No',
				value: 0
			}
		];
	}
	static get getOrganizationTypeId() {
		return [
			{
				value: 'city',
				text: 'City of Winnipeg'
			},
			{
				value: 'province',
				text: 'Province of Manitoba'
			},
			{
				value: 'utility',
				text: 'Utility'
			},
			{
				value: 'agency',
				text: 'Construction Agency'
			},
			{
				value: 'other',
				text: 'Other'
			},
		];
	}
	static get getIsApprovedOptions() {
		return [
			{
				value: null,
				text: "Pending"
			},
			{
				value: 1,
				text: "Approved"
			},
			{
				value: 0,
				text: "Rejected"
			},
		];
	}
	static get getIsActiveOptions() {
		return [
			{
				value: 1,
				text: "Active"
			},
			{
				value: 0,
				text: "Inactive"
			},
		];
	}
	static get getSortOptions() {
		return [
			{
				text: 'Organization A->Z',
				value: 'name asc'
			},
			{
				text: 'Organization Z->A',
				value: 'name desc'
			},
			{
				text: 'Date Created - Newest Request First',
				value: 'createdDate desc'
			},
			{
				text: 'Date Created - Oldest Request First',
				value: 'createdDate asc'
			},
		]
	}
	constructor(data) {
		if (!data) {
			data = {};
		}
		Object.assign(this, {
			id: data.id || null,
			name: new BootstrapField({
				value: data.name || null,
				required: true,
			}),
			domain: new BootstrapField({
				value: data.domain || null,
			}),
			comments: new BootstrapField({
				value: data.comments || null,
			}),
			firstName: new BootstrapField({
				value: data.firstName || null,
				required: true,
				type: BootstrapField.Types.text,
			}),
			lastName: new BootstrapField({
				value: data.lastName || null,
				required: true,
				type: BootstrapField.Types.text,
			}),
			title: new BootstrapField({
				value: data.title || null,
			}),
			email: new BootstrapField({
				value: data.email || null,
				required: true,
				type: BootstrapField.Types.text,
			}),
			phone: new BootstrapField({
				value: data.phone || null,
				required: true,
				type: BootstrapField.Types.text,
			}),
			altPhone: new BootstrapField({
				value: data.altPhone || null,
			}),
			createdDate: new BootstrapField({
				value: data.createdDate || null,
			}),
			isApproved: new BootstrapField({
				value: typeof data.isApproved === 'number' ? data.isApproved : null,
			}),
			approvalDate: new BootstrapField({
				value: data.approvalDate || null,
			}),
			approvalUserId: new BootstrapField({
				value: data.approvalUserId || null,
			}),
			sourceIp: new BootstrapField({
				value: data.sourceIp || null,
			}),
			emailConfirmed: new BootstrapField({
				value: data.emailConfirmed || null,
			}),

			orgAdminUsername: new BootstrapField({
				value: data.orgAdminUsername || null,
			}),

			orgAdminPassword: new BootstrapField({
				value: data.orgAdminPassword || null,
			}),
		});

		// Keep a record of the old data. (used for the hasChanges() method)
		// originalOrganizationData = CloneDeep(this);
	}

	validate() {
		let flag = true;
		let errors = [];
		for (let field in this) {
			if (this[field] instanceof BootstrapField) {
				let result = this[field].validate();
				if (result === false) {
					errors.push(field);
					flag = false;
				}
			}
		}
		return flag;
	}

	getRawValue() {
		return getRawValue(this);

		function getRawValue(obj) {
			let value = {};
			if (obj instanceof BootstrapField) {
				value = obj.getRawValue();
			} else if (obj instanceof Object && Object.keys(obj).length > 0) {
				for (let key in obj) {
					if (obj[key] instanceof Array) {
						value[key] = [];
						for (let arrKey in obj[key]) {
							value[key].push(getRawValue(obj[key][arrKey]));
						}
					} else {
						value[key] = getRawValue(obj[key]);
					}
				}
			} else if (obj instanceof Array && obj.length > 0) {
				// This shouldnt ever run, as an array is also an object.
			}
			// Default, just return the value;
			else {
				value = obj;
			}
			return value;
		}
	}

	getValue() {
		return getValue(this);

		function getValue(obj) {
			let value = {};
			if (obj instanceof BootstrapField) {
				value = obj.getValue();
			} else if (obj instanceof Object && Object.keys(obj).length > 0) {
				for (let key in obj) {
					if (obj[key] instanceof Array) {
						value[key] = [];
						for (let arrKey in obj[key]) {
							value[key].push(getValue(obj[key][arrKey]));
						}
					} else {
						value[key] = getValue(obj[key]);
					}
				}
			} else if (obj instanceof Array && obj.length > 0) {
				// This shouldnt ever run, as an array is also an object.
			}
			// Default, just return the value;
			else {
				value = obj;
			}
			return value;
		}
	}


	hasChanges() {

		// var differences = DeepDiff.diff(originalOrganizationData.getRawValue(),  this.getRawValue());

		// return !IsEqual(originalOrganizationData.getRawValue(), this.getRawValue());
		return false;
	}
	revertChanges() {
		// this.constructor(originalOrganizationData);
	}
	saveChanges() {
		// originalOrganizationData = CloneDeep(this);
	}
}